import { useCallback } from 'react';
import apiClient from 'src/api/axiosClient';
import {
  GetStripeCustomerSecretsApiParams,
  GetStripePublishableKeyApiParams,
  GetStripePaymentMethodsApiParams,
  DetachPaymentMethodApiParams,
  SetDefaultPaymentMethodApiParams,
} from '../types/StripeApi';

export function useGetStripeCustomerSecretsApi(): GetStripeCustomerSecretsApiParams {
  return useCallback((companyId: string) => apiClient.get(`/companies/${companyId}/stripe-customer-secrets`), []);
}

export function useGetStripePublishableKeyApi(): GetStripePublishableKeyApiParams {
  return useCallback((companyId: string) => apiClient.get(`/companies/${companyId}/stripe-pkey`), []);
}

export function useGetStripePaymentMethodsApi(): GetStripePaymentMethodsApiParams {
  return useCallback((companyId: string) => apiClient.get(`/companies/${companyId}/payment-methods`), []);
}

export function useDetachPaymentMethodApi(): DetachPaymentMethodApiParams {
  return useCallback(
    (companyId: string, paymentMethodId: string) => apiClient.delete(`/companies/${companyId}/payment-methods/${paymentMethodId}`),
    [],
  );
}

export function useSetDefaultPaymentMethodApi(): SetDefaultPaymentMethodApiParams {
  return useCallback(
    (companyId: string, paymentMethodId: string) => apiClient.put(`/companies/${companyId}/payment-methods/${paymentMethodId}/default`),
    [],
  );
}